









































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Pagination from "@/components/shared/Pagination.vue";
import { CPMDocumentDTO, Filter, SearchMetadataDto } from "@/model/data.model";
import {
  IPagination,
  SearchParams,
  ShipmentListItem,
  PresetField
} from "@/model/component.model";
import { ShipmentService } from "@/services/ShipmentService";
import { SearchService } from "@/services/SearchService";
import { SearchExport } from "../shared/SearchExport";
import {
  alertDangerReason,
  displayPdf,
  downloadFileBase64
} from "@/services/Helpers";
import i18n from "@/lang/i18n";
import shipment from "@/vuex/modules/shipment";
import { sortBy } from "lodash";
import { getStoreId } from "@/services/AuthService";
import { EventBus } from "@/event-bus";
import { format } from "date-fns";
import date from "@/filters/DateFilter";
import datetime from "@/filters/DateTimeFilter";

@Component({
  components: {
    Pagination: Pagination
  }
})
export default class CourierPickupsManagementTable extends Vue {
  SearchExport: SearchExport = new SearchExport();

  @Prop({})
  mbeDocumentTypesId?: number;
  @Prop() filter?: any;
  @Prop() metadata?: SearchMetadataDto;
  @Prop() presetsVisible?: any;
  @Prop({ default: 900 })
  maxHeight?: number;
  @Prop({
    default: () => {
      return [];
    }
  })
  @Prop({})
  courier?: number;
  CPMDocument: CPMDocumentDTO[] = [];
  selected = [];
  singleSelected = "";
  topScrollbarContentWidth = 0;
  allDocumentsSelected = false;
  scrolling = false;

  searchParams: SearchParams = {
    search: "",
    orderField: "creationDate",
    orderDirection: "desc",
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    page: 0,
    pageSize: 25
  };
  ship = [];

  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25, 50, 100, 200, 500]
  };

  createFilter(searchFiled, filter) {
    if (filter.type === "DATE" && searchFiled.length > 1) {
      return [
        {
          field: filter.field,
          type: filter.type,
          operation: ">=",
          values: [searchFiled[0]]
        },
        {
          field: filter.field,
          type: filter.type,
          operation: "<=",
          values: [searchFiled[1]]
        }
      ];
    } else {
      return [
        {
          field: filter.field,
          type: filter.type,
          operation: "=",
          values: [searchFiled]
        }
      ];
    }
  }
  createFilters() {
    const and = [];
    this.metadata.filters.forEach(filter => {
      and.push(...this.createFilter(this.filter[filter.field], filter));
    });
    return and;
  }
  getDataTable() {
    const request = {
      and: this.createFilters().filter(item => item.values[0]),
      or: []
    } as Filter;
    request.and.push({
      field: "active",
      type: "BOOLEAN",
      operation: "=",
      values: [true]
    });
    const sort =
      this.searchParams.orderField && this.searchParams.orderDirection
        ? this.searchParams.orderField + " " + this.searchParams.orderDirection
        : "pickup.pickupDate desc";

    const pagination = {
      s: 1,
      sortBy: sort + ",pickup.creationDate desc",
      page: this.pagination.currentPage - 1,
      pageSize: this.pagination.perPage
    };

    SearchService.search(
      "shipments",
      "shipments-pickup",
      request,
      pagination.sortBy,
      pagination.pageSize,
      pagination.page,
      pagination.s
    ).then(res => {
      this.searchParams.numberOfElements = res.numberOfElements;
      this.searchParams.totalElements = res.totalElements;
      this.pagination.totalElements = res.totalElements;
      this.searchParams.totalPages = res.totalPages;
      this.ship = res.content;
      this.ship.forEach(function(element) {
        element.selected = false;
      });
      Vue.nextTick(() => {
        this.addResizeListner();
        const tableClass = document.getElementById("resizeMe");
        const scrollbar1 = document.getElementById("scrollbar1");
        const scrollbar2 = document.getElementById("scrollbar2");
        const width = tableClass.offsetWidth;
        scrollbar1.style.width = width.toString() + "px";
        scrollbar2.style.width = width.toString() + "px";
      });
    });
  }
  addResizeListner() {
    // window.addEventListener("DOMContentLoaded", function() {
    const createResizableTable = function(table) {
      const cols = table.querySelectorAll("th");
      [].forEach.call(cols, function(col: any) {
        // Add a resizer element to the column
        const resizer = document.createElement("div");
        resizer.classList.add("resizer");
        resizer.style.height = `${col.offsetHeight}px`;
        resizer.style.top = `0`;
        resizer.style.right = `0`;
        resizer.style.position = `absolute`;
        resizer.style.width = `10px`;
        resizer.style.cursor = "col-resize";
        col.appendChild(resizer);

        createResizableColumn(col, resizer);
      });
    };
    const createResizableColumn = function(col, resizer) {
      let x = 0;
      let w = 0;

      const mouseDownHandler = function(e) {
        x = e.clientX;

        const styles = window.getComputedStyle(col);
        w = parseInt(styles.width, 10);

        document.addEventListener("mousemove", mouseMoveHandler);
        document.addEventListener("mouseup", mouseUpHandler);

        resizer.classList.add("resizing");
      };
      const mouseMoveHandler = function(e) {
        const dx = e.clientX - x;
        col.style["min-width"] = `${w + dx}px`;
        const tableClass = document.getElementById("resizeMe");
        const scrollbar1 = document.getElementById("scrollbar1");
        const scrollbar2 = document.getElementById("scrollbar2");
        const width = tableClass.offsetWidth;
        scrollbar1.style.width = width.toString() + "px";
        scrollbar2.style.width = width.toString() + "px";
      };

      const mouseUpHandler = function() {
        resizer.classList.remove("resizing");
        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
      };

      resizer.addEventListener("mousedown", mouseDownHandler);
    };

    createResizableTable(document.getElementById("resizeMe"));
  }

  searchResults() {
    this.pagination = {
      currentPage: 1,
      perPage: 25,
      totalElements: 0,
      perPageOptions: [25, 50, 100, 200, 500]
    };
    this.getDataTable();
  }

  created() {
    EventBus.$on("search-on-pickup-management", this.searchResults);
    this.getDataTable();
  }

  searchHandler(pagination: IPagination) {
    this.pagination = pagination;
    this.searchParams.page = pagination.currentPage - 1;
    this.searchParams.pageSize = pagination.perPage;
    this.getDataTable();
  }

  destroyed() {
    EventBus.$off("search-on-pickup-management", this.searchResults);
  }
  selectAll(value: boolean) {
    this.allDocumentsSelected = value;
    this.selected = [];
    this.ship.forEach((document: CPMDocumentDTO) => {
      document.selected = value;
      if (value) this.selected.push(document.id);
    });
    this.$emit("selected-changed", this.selected);
  }

  showCPMModal(openItem: any) {
    this.$emit("showCPMModal", openItem);
  }

  selectItem(item: any) {
    item.selected = !item.selected;
    this.selected = this.ship.filter(item => item.selected === true);
    this.$emit("single-selected-changed", this.ship);
  }

  tableScrolling($event: any) {
    (this.$refs.topScrollbar as HTMLElement).scrollLeft =
      $event?.target?.scrollLeft || 0;
  }
  setTopScrollBarWidth() {
    this.topScrollbarContentWidth =
      (this.$refs.table as HTMLElement).clientWidth - 1;
  }

  topScrolling($event: any) {
    (this.$refs.tablecontainer as HTMLElement).scrollLeft =
      $event.target.scrollLeft;
  }

  exportAsXls() {
    const filename =
      "export_" + format(new Date(), "yyyy-MM-dd_HHmm") + ".xlsx";
    let data;
    if (!this.selected || this.selected.length === 0) data = this.ship;
    else data = this.selected;
    this.SearchExport.exportToXlsx(filename, this.processData(data));
    // this.$emit("metaExportXlsx", { filename: filename, context: this.context });
  }

  // translate data as in the page
  processData(rows: any[]) {
    const self: any = this;
    const processRow = function(r: any) {
      const map: any = {};
      for (let i = 0; i < self.presetsVisible.length; i++) {
        const p = self.presetsVisible[i];
        const key: any = i18n.t(p.field);
        const value = self.filterColumnValueXlsx(
          self.getValueFromObject(r, p.field),
          p.type,
          p.typeSpec
        );
        map[key] = value;
      }
      return map;
    };
    const data: any = [];
    rows.forEach((r: any) => {
      data.push(processRow(r));
    });
    return data;
  }

  filterColumnValueXlsx(value: any, type: any, typeSpec: any) {
    if (type === "DECIMAL" || type === "CURRENCY") {
      return value;
    } else if (type === "DATE") {
      return date(value);
    } else if (type === "DATETIME") {
      return datetime(value);
    }
    return value;
  }

  getValueFromObject(object: any, field: string) {
    function index(object: any, i: string) {
      if (!object) return null;
      // feat #2299: handle array fields
      if (Array.isArray(object)) {
        if (i == "documentDueDate") {
          const index = object.findIndex(element => !element.paymentDone);
          if (index != -1) return object[index][i];
        } else if (i == "lastPaymentDate") {
          let lastDate = "";
          object.forEach(item => {
            if (lastDate === "" && item.lastPaymentDate) {
              lastDate = item.lastPaymentDate;
            } else {
              if (
                item.lastPaymentDate &&
                item.lastPaymentDate.replace(/-/g, "/") >
                  lastDate.replace(/-/g, "/")
              ) {
                lastDate = item.lastPaymentDate;
              }
            }
          });
          return lastDate;
        } else if (i == "amount") {
          let amount = 0;
          object.map(item => {
            amount += item.amount;
          });
          return amount;
        } else if (i == "balance") {
          let balance = 0;
          object.map(item => {
            balance += item.balance;
          });
          return balance;
        } else if (i == "paidAmount") {
          let paidAmount = 0;
          object.map(item => {
            if (item.paidAmount) paidAmount += item.paidAmount;
          });
          return paidAmount;
        } else {
          return object[0] ? object[0][i] : undefined;
        }
      }
      return object[i];
    }
    return field.split(".").reduce(index, object);
  }

  getTranslatedFieldName(preset: any): string {
    return String(this.$i18n.t(preset.field));
  }

  getField(row, field) {
    const fields = field.split(".");
    switch (fields.length) {
      case 1:
        return row[fields[0]];
      case 2:
        return row[fields[0]][fields[1]];
      case 3:
        return row[fields[0]][fields[1]][fields[2]];
    }
  }

  selectOrderFieldAndDirection(orderField: string, order: string) {
    if (this.searchParams.orderField === orderField) {
      this.searchParams.orderDirection = order;
    } else {
      this.searchParams.orderField = orderField;
      this.searchParams.orderDirection = order;
    }

    this.getDataTable();
  }
  handleScroll1() {
    if (this.scrolling) {
      this.scrolling = false;
      return;
    }
    this.scrolling = true;
    const wrapper1 = document.getElementById("wrapper1");
    const wrapper2 = document.getElementById("wrapper2");
    wrapper2.scrollLeft = wrapper1.scrollLeft;
  }
  handleScroll2() {
    if (this.scrolling) {
      this.scrolling = false;
      return;
    }
    this.scrolling = true;
    const wrapper1 = document.getElementById("wrapper1");
    const wrapper2 = document.getElementById("wrapper2");
    wrapper1.scrollLeft = wrapper2.scrollLeft;
  }
}
